export const CANADIAN_PROVINCES = [
  { state: 'ALBERTA', code: 'AB' },
  { state: 'BRITISH COLUMBIA', code: 'BC' },
  { state: 'MANITOBA', code: 'MB' },
  { state: 'NEW BRUNSWICK', code: 'NB' },
  { state: 'NEWFOUNDLNAD AND LABRADOR', code: 'NL' },
  { state: 'NORTHWEST TERRITORIES', code: 'NT' },
  { state: 'NOVA SCOTIA', code: 'NS' },
  { state: 'NUNAVUT', code: 'NU' },
  { state: 'ONTARIO', code: 'ON' },
  { state: 'PRINCE EDWARD ISLAND', code: 'PE' },
  { state: 'QUEBEC', code: 'QC' },
  { state: 'SASKATCHEWAN', code: 'SK' },
  { state: 'YUKON', code: 'YT' }
];

export const BRAZILIAN_STATES = [
  { state: 'ACRE', code: 'AC' },
  { state: 'ALAGOAS', code: 'AL' },
  { state: 'AMAZONAS', code: 'AM' },
  { state: 'AMAPÁ', code: 'AP' },
  { state: 'BAHIA', code: 'BA' },
  { state: 'CEARÁ', code: 'CE' },
  { state: 'DISTRITO FEDERAL', code: 'DF' },
  { state: 'ESPÍRITO SANTO', code: 'ES' },
  { state: 'GOIÁS', code: 'GO' },
  { state: 'MARANHÃO', code: 'MA' },
  { state: 'MINAS GERAIS', code: 'MG' },
  { state: 'MATO GROSSO DO SUL', code: 'MS' },
  { state: 'MATO GROSSO', code: 'MT' },
  { state: 'PARÁ', code: 'PA' },
  { state: 'PARAÍBA', code: 'PB' },
  { state: 'PERNAMBUCO', code: 'PE' },
  { state: 'PIAUÍ', code: 'PI' },
  { state: 'PARANÁ', code: 'PR' },
  { state: 'RIO DE JANEIRO', code: 'RJ' },
  { state: 'RIO GRANDE DO NORTE', code: 'RN' },
  { state: 'RONDÔNIA', code: 'RO' },
  { state: 'RORAIMA', code: 'RR' },
  { state: 'RIO GRANDE DO SUL', code: 'RS' },
  { state: 'SANTA CATARINA', code: 'SC' },
  { state: 'SERGIPE', code: 'SE' },
  { state: 'SÃO PAULO', code: 'SP' },
  { state: 'TOCANTINS', code: 'TO' }
];